import React from 'react';
import {
  Button, FormControl, InputLabel, MenuItem, Select, Stack,
  TextField, Typography,
} from '@mui/material';

/**
 * Filter + bulk-action toolbar above the threshold table.
 *
 * Shows pending-changes count when the parent has unsaved threshold
 * edits, plus the Discard / Save buttons (both disabled when there's
 * nothing to commit or a save is in flight).
 */
export default function LowStockToolbar({
  filter, onFilterChange,
  search, onSearchChange,
  dirtyCount, saving,
  onDiscard, onSave,
}) {
  return (
    <Stack
      direction='row' justifyContent='space-between' alignItems='center'
      flexWrap='wrap' gap='10px' mb='10px'
    >
      <Stack direction='row' spacing='8px' alignItems='center' flex='1' flexWrap='wrap'>
        <FormControl size='small' sx={{ minWidth: 200 }}>
          <InputLabel shrink>Filter</InputLabel>
          <Select displayEmpty label='Filter' value={filter} onChange={(e) => onFilterChange(e.target.value)}>
            <MenuItem value='low_out'>Low + out</MenuItem>
            <MenuItem value='out'>Out only</MenuItem>
            <MenuItem value='low'>Low only</MenuItem>
            <MenuItem value='ok'>OK</MenuItem>
            <MenuItem value=''>All</MenuItem>
          </Select>
        </FormControl>
        <TextField
          size='small'
          placeholder='Search by name, variant, or SKU'
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          sx={{ maxWidth: 320 }}
        />
      </Stack>
      <Stack direction='row' spacing='8px' alignItems='center' flexWrap='wrap'>
        {dirtyCount > 0 && (
          <Typography variant='body2' color='text.secondary'>
            {dirtyCount} pending change{dirtyCount === 1 ? '' : 's'}
          </Typography>
        )}
        <Button size='small' onClick={onDiscard} disabled={dirtyCount === 0 || saving}>
          Discard
        </Button>
        <Button size='small' variant='contained' onClick={onSave} disabled={dirtyCount === 0 || saving}>
          {saving ? 'Saving…' : 'Save thresholds'}
        </Button>
      </Stack>
    </Stack>
  );
}
